module.exports = __webpack_public_path__ + "img/2.f49a0ff8.png";